import { cmxTypeguards } from '@codametrix/ui-common';
export const isSubscriptionTransformer = (subscription)=>{
    return 'match' in subscription;
};
export const isSubscriptionObserver = (subscription)=>{
    return 'observe' in subscription;
};
export const passthrough = (action)=>action;
export const receiverFactory = (channel)=>{
    return (subscriptions, store)=>{
        const transformers = subscriptions.filter(isSubscriptionTransformer);
        const observers = subscriptions.filter(isSubscriptionObserver);
        transformers.forEach((receiver)=>{
            receiver.transform = receiver.transform ?? passthrough;
        });
        // For WindowProxy (window.postMessage), validate message origin to prevent
        // cross-origin attacks. BroadcastChannel is same-origin by design.
        const isWindowProxy = 'location' in channel && 'postMessage' in channel;
        const expectedOrigin = isWindowProxy ? channel.location.origin : null;
        channel.addEventListener('message', (message)=>{
            // Validate origin for WindowProxy messages
            if (expectedOrigin && 'origin' in message && message.origin !== expectedOrigin) {
                return;
            }
            // subscriptions deal with actions instead of MessageEvents
            // if a message comes across the channel that isn't an action
            // it is ignored for now.
            if ('data' in message && cmxTypeguards.isReduxAction(message.data)) {
                const action = message.data;
                // observers go first.
                observers.forEach((observer)=>observer.observe(action));
                const dispatchables = transformers.filter((receiver)=>receiver.match(action));
                dispatchables.forEach((dispatchable)=>{
                    // trans guaranteed to be there from lines above.
                    const toDispatch = dispatchable.transform({
                        ...action
                    });
                    store.dispatch(toDispatch);
                });
            }
        });
    };
};
